/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * A Component to show hour summations in the banner of the planboard.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["em[_ngcontent-%COMP%]{color:#6c757d}.sym-row-info[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}"];
export { styles as styles };
